import React, { useEffect, useState } from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { Divider, Modal, Tag, Tooltip } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { useMessage } from "../MessageProvider/MessageProvider";
import { IoMdInformationCircleOutline } from "react-icons/io";
import axiosInstance from "../axiosInstance/AxiosInstance";
import YukXatiListItem from "./YukXatiListItem";

export default function YukXatiList({ data, setData, selected, setSelected }) {
  const messageApi = useMessage();
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [loading, setLoading] = useState(false);
  let [info, setInfo] = useState(null);

  let getYukXati = async (id) => {
    try {
      setLoading(true);
      console.log(id);

      let { data } = await axiosInstance.get("/api/chiqim/" + id);

      if (data.success) {
        console.log("data");
        console.log(data.data[0]);
        setInfo(data.data[0]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (!data) return null;

  return (
    // className="relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 max-w-[900px] m-auto w-[100%] flex flex-row items-center justify-between text-[12px]"
    <div className="max-w-[900px] w-[100%] overflow-auto m-auto flex flex-col items-start gap-[1px] ">
      {data?.map((el, i) => {
        return (
          <>
            {data[i - 1]?.created_at?.split("T")[0] ==
            data[i]?.created_at?.split("T")[0] ? null : (
              <Divider orientation="center" className="mx-1">
                {data[i].created_at?.split("T")[0]}
              </Divider>
            )}
            <YukXatiListItem
              el={el}
              data={data}
              setData={setData}
              setSelected={setSelected}
              selected={selected}
            />
          </>
        );
      })}
    </div>
  );
}
// naqtga = #86efac
// nasiya = #fb7185
// ticket = #fef08a
